import { useState, FormEvent } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { authApi } from '@/services/api';
import { validatePassword } from '@/utils/password';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const navigate = useNavigate();
  const [pw, setPw] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    const v = validatePassword(pw);
    if (v) { setErr(v); return; }
    setErr('');
    setLoading(true);
    try {
      await authApi.resetPassword(token, pw);
      navigate('/login');
    } catch (e2) {
      setErr(e2 instanceof Error ? e2.message : '重置失败，链接可能已失效');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <main className="w-full bg-background-50 min-h-[calc(100vh-200px)] flex items-center justify-center">
        <div className="w-full max-w-md mx-auto px-4 py-10">
          <div className="bg-background-50 rounded-xl border border-background-200 p-6 md:p-8">
            <h1 className="font-heading text-2xl font-bold text-foreground-900 text-center mb-6">设置新密码</h1>
            {!token ? (
              <p className="text-sm text-foreground-600 text-center">
                无效的重置链接。<Link to="/forgot-password" className="text-primary-600">重新申请</Link>
              </p>
            ) : (
              <form onSubmit={submit} className="space-y-5">
                <div>
                  <label htmlFor="pw" className="block text-foreground-700 text-sm font-medium mb-1.5">新密码</label>
                  <input
                    id="pw" type="password" value={pw}
                    onChange={(e) => setPw(e.target.value)}
                    placeholder="≥8位，含大写字母、数字、特殊字符"
                    className="w-full bg-background-50 border border-background-300 rounded-md px-3 py-2.5 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                  />
                </div>
                {err && <p className="text-accent-700 text-xs">{err}</p>}
                <button type="submit" disabled={loading}
                  className="w-full py-2.5 bg-primary-500 text-background-50 text-sm font-medium rounded-md hover:bg-primary-600 transition-colors disabled:opacity-60">
                  {loading ? '提交中...' : '确认重置'}
                </button>
              </form>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
